<template>
	<div id="utilities">
		<div class="material-wrapper">
			<div class="material-section">
				<img src="/static/calculator.png" style="display:block; width:64px" />
				<h5>Calculator</h5>
				<p>A Standard Calculator</p>
				<b-link class="btn btn-primary" to="/dashboard/calculator" style="margin-top:20px">Open</b-link>
			</div>
			<div class="material-section">
				<img src="/static/reload.png" style="display:block; width:64px" />
				<h5>Unit Convertor</h5>
				<p>Easily convert units from Area, Mass, Power, Force, etc.</p>
				<b-link class="btn btn-primary" to="/dashboard/unit-convertor" style="margin-top:20px">Open</b-link>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name:'Utilities',
	data: function() {
		return {

		}
	}
}
</script>

<style scoped>
.material-wrapper {
	margin-top:30px;
}
.material-section {
	padding: 20px;
	background-color: white;
	box-shadow: 0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);
	border-radius: 5px;
	margin-top: 10px;
}
.material-section h5 {
	font-weight: bold;
	color:black;
}
.material-section img {
	margin:10px auto 30px;
}
.material-section p {
	margin-bottom: 0;
	color: #696969;
}

.material-section .btn {
	margin: auto;
}
@media screen and (min-width: 1024px) {
	.material-wrapper {
		display: flex;
		align-items: center;
	}
	.material-section {
		width: 33%;
		flex-basis: 33%;
		margin:10px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Utilities.vue